import { Breadcrumbs, H3, Layout as LayoutMagik, Menu } from "@inmagik/magik-ui"
import classNames from "classnames"
import { useAuth } from "../auth"
import { Link } from "react-router-dom"

export default function Layout({ children, scrollable = false }: { children: React.ReactNode; scrollable?: boolean }) {
  const { performLogout, user } = useAuth()
  return (
    <LayoutMagik className="temp-layout-fix">
      <LayoutMagik.Header className="px-4 py-2">
        <LayoutMagik.Header.Left className="d-flex align-items-center">
          <Link
            to="/"
            style={{
              textDecoration: "none",
            }}
          >
            <div
              style={{
                fontSize: "1.5rem",
                fontWeight: "bold",
                color: "var(--primary)",
              }}
            >
              Bipec Admin
            </div>
          </Link>
        </LayoutMagik.Header.Left>
        <LayoutMagik.Header.Center className="d-flex align-items-center">
          <Breadcrumbs />
        </LayoutMagik.Header.Center>
        <LayoutMagik.Header.Right>
          <Menu.Item
            title="Logout"
            icon="logout"
            onClick={() => {
              performLogout()
            }}
          />
        </LayoutMagik.Header.Right>
      </LayoutMagik.Header>
      <LayoutMagik.SidebarLeft className="py-5 px-4">
        <Menu className="h-100">
          <Menu.Item title="Dashboard" link="/" />
          <Menu.Section title="Opere">
            <Menu.Section.Item title="Opere" link="/opere/opere" />
            <Menu.Section.Item title="Persone" link="/opere/persone" />
          </Menu.Section>
          <Menu.Section title="Edizioni">
            <Menu.Section.Item title="Edizioni" link="/edizioni/edizioni" />
            <Menu.Section.Item title="Esemplari" link="/edizioni/esemplari" />
            <Menu.Section.Item title="Facsímili" link="/edizioni/facsimili" />
            <Menu.Section.Item title="Paratesti" link="/edizioni/paratesti" />
            <Menu.Section.Item title="Immagini" link="/edizioni/immagini" />
            <Menu.Section.Item title="Formati" link="/edizioni/formati" />
          </Menu.Section>
          <Menu.Item title="Città" link="/citta/citta" />
          <Menu.Item title="Biblioteche" link="/biblioteche/biblioteche" />
          <Menu.Item title="Tags" link="/tags/tags" />
          <Menu.Item title="Tipologie Immagini" link="/tipologie-immagini/tipologie-immagini" />
          <Menu.Item title="Tecniche Immagini" link="/tecniche-immagini/tecniche-immagini" />
          <Menu.Item title="Testi" link="/testi/testi" />
          <Menu.Item title="Gruppo di ricerca" link="/gruppi-di-ricerca/gruppi-di-ricerca" />

          <Menu.Divider />

          <Menu.Item title="Atlanti" link="/atlanti/atlanti" />
          <Menu.Item title="Tavole" link="/atlanti/tavole" />
          <Menu.Item title="Relazioni" link="/atlanti/relazioni" />
          
          <Menu.FillEmptySpace />
          
          {user?.can_delete_data && <Menu.Item title="Utenti" link="/utenti/utenti" />}

          <Menu.Item title="Profilo" link="/profilo" />
        </Menu>
      </LayoutMagik.SidebarLeft>
      {/* <Layout.SidebarRight>Right</Layout.SidebarRight> */}
      <LayoutMagik.Main
        className={classNames("w-100 h-100 px-6 py-4", {
          "overflow-auto": scrollable,
        })}
      >
        {children}
      </LayoutMagik.Main>
    </LayoutMagik>
  )
}
